import { render, staticRenderFns } from "./CalculationResults.vue?vue&type=template&id=a51a4f88"
import script from "./CalculationResults.vue?vue&type=script&lang=js"
export * from "./CalculationResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports